
/* V2: accessible left drawer and multilingual responsive footer. */
(() => {
  const words={
    fr:{intro:'Diamants de laboratoire. Approvisionnement direct. Accompagnement à Paris.',project:'Parlons de votre projet.',contact:'Contacter la Maison',navigation:'Explorer',services:'Professionnels',paris:'Paris · France',china:'Shenzhen · Chine',close:'Fermer le menu',menu:'MENU PRINCIPAL',backdrop:'Fermer le menu'},
    en:{intro:'Lab-grown diamonds. Direct sourcing. Support from Paris.',project:'Let’s discuss your project.',contact:'Contact the Maison',navigation:'Explore',services:'Professionals',paris:'Paris · France',china:'Shenzhen · China',close:'Close menu',menu:'MAIN MENU',backdrop:'Close menu'},
    de:{intro:'Laborgezüchtete Diamanten. Französische Ansprüche. Dauerhafte Partnerschaften.',project:'Sprechen wir über Ihr Projekt.',contact:'Kontakt aufnehmen',navigation:'Entdecken',services:'Fachhandel',paris:'Paris · Frankreich',china:'Shenzhen · China',close:'Menü schließen',menu:'HAUPTMENÜ',backdrop:'Menü schließen'},
    it:{intro:'Diamanti di laboratorio. Esigenza francese. Collaborazioni durature.',project:'Parliamo del tuo progetto.',contact:'Contatta la Maison',navigation:'Esplora',services:'Professionisti',paris:'Parigi · Francia',china:'Shenzhen · Cina',close:'Chiudi il menu',menu:'MENU PRINCIPALE',backdrop:'Chiudi il menu'},
    es:{intro:'Diamantes de laboratorio. Exigencia francesa. Colaboraciones duraderas.',project:'Hablemos de tu proyecto.',contact:'Contactar con la Maison',navigation:'Explorar',services:'Profesionales',paris:'París · Francia',china:'Shenzhen · China',close:'Cerrar el menú',menu:'MENÚ PRINCIPAL',backdrop:'Cerrar el menú'}
  };
  const drawer=document.getElementById('mmenu');
  const shade=document.querySelector('.n-menu-shade');
  const close=document.querySelector('.n-menu-close');
  const trigger=document.getElementById('burger');
  const original=setLang;
  function apply(){
    const d=words[LANG]||words.fr;
    document.querySelectorAll('[data-v2]').forEach(el=>{if(!el.hasAttribute('data-ch-editable'))el.textContent=d[el.dataset.v2]||'';});
    close.setAttribute('aria-label',d.close);shade.setAttribute('aria-label',d.backdrop);
    drawer.setAttribute('aria-label',d.menu);
    document.querySelectorAll('[data-footer-lang]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.footerLang===LANG)));
  }
  setLang=function(l){original(l);apply();};apply();
  document.querySelectorAll('[data-footer-lang]').forEach(b=>b.addEventListener('click',()=>setLang(b.dataset.footerLang)));
  let wasOpen=false;
  const main=document.getElementById('n-main'),footer=document.querySelector('footer.f2');
  function sync(){
    const opened=drawer.classList.contains('open');
    shade.classList.toggle('on',opened);shade.setAttribute('aria-hidden',String(!opened));
    drawer.setAttribute('role','dialog');drawer.setAttribute('aria-modal',String(opened));
    main.inert=opened;footer.inert=opened;
    if(opened&&!wasOpen){close.focus({preventScroll:true});}
    if(!opened&&wasOpen){trigger.focus({preventScroll:true});}
    wasOpen=opened;
  }
  shade.addEventListener('click',closeMenu);close.addEventListener('click',closeMenu);
  new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['class']});sync();
  document.addEventListener('keydown',e=>{
    if(e.key!=='Tab'||!drawer.classList.contains('open'))return;
    const links=Array.from(drawer.querySelectorAll('button,a[href]')).filter(x=>!x.disabled&&x.getClientRects().length);
    if(!links.length)return;
    const first=links[0],last=links[links.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });
  addEventListener('resize',()=>{if(innerWidth>=1280)closeMenu();},{passive:true});
})();

